import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BurgerMenuButtonComponent } from './burger-menu-button.component';

@NgModule({
  imports: [CommonModule],
  declarations: [BurgerMenuButtonComponent],
  exports: [BurgerMenuButtonComponent],
})
export class BurgerMenuButtonModule {}
